import { tryStartLoadingNavContent } from "src/app/nav-content/tryStartLoadingNavContent";
import NProgress from "src/standard/ts/nprogress-customizations";

export function init() {
  return async () => {
    NProgress.start();

    // Earliest point to start loading nav content
    void tryStartLoadingNavContent();
  };
}
